import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { msalConfig } from '../authConfig';
import { PublicClientApplication } from '@azure/msal-browser';
/*import { Button } from "bootstrap"*/
import Button from 'react-bootstrap/Button';

import './NavMenu.css';

export const SignOut = () => {
    const { instance } = useMsal();
    /*const myMSALObj = new PublicClientApplication(msalConfig);*/

    const handleLogin = (e) => {
        //instance.logoutRedirect();
        /* console.log("Hello world")*/
        console.log(e);
        
        instance.logoutRedirect({
            postLogoutRedirectUri: '/', // Where to redirect after logout
        });
    };

    return (
        <div id="Logout">
            <input type="submit" value="Sign Out" className="btn" style={{ backgroundColor: "#563abe", color: "#ffffff", fontSize: "1.2rem", fontWeight: "600", marginLeft: "1vh" }} onClick={handleLogin} />
        {/*    <a className="btn btn-info bg-white text-dark" role="button" onClick={handleLogin}>Sign Out</a>*/}
        </div>
    );
}